import { Container } from 'reactstrap';
import CaseFollowUpList from '../../../Component/Application/CaseFollowUp/CaseFollowUpList';
import Breadcrumbs from '../../../CommonElements/Breadcrumbs/Breadcrumbs';
import { useTranslation } from 'react-i18next';

const CaseFollowUpAdmin = () => {
  const { t } = useTranslation();

  return (
    <div className='page-body'>
      <Breadcrumbs mainTitle={t('Seguimiento de Casos')} parent={t('Aplicaciones')} />
      <Container fluid>
        <CaseFollowUpList viewType="admin-all" />
      </Container>
    </div>
  );
};

export default CaseFollowUpAdmin;

